import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";

const DealBanner = () => {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundImage:
          "url('https://png.pngtree.com/thumb_back/fh260/background/20241106/pngtree-small-shopping-cart-with-coins-and-a-gift-box-on-a-image_16527291.jpg')", // Correct image URL
        backgroundSize: "cover", // Ensures the image covers the entire section
        backgroundPosition: "center", // Centers the image
        height: "400px", // Adjust the height of the section as needed
        color: "white", // Text color for contrast against the background
        padding: "50px 0",
      }}
    >
      <Row className="text-left w-100">
        <Col>
          <h1 className="mb-4" style={{ fontWeight: "bold" }}>
            Get the best deal for Grocery
          </h1>
          <p className="mb-4" style={{ fontSize: "1.1rem" }}>
            You get into the 2k+ best Products in Flash offer with as into the find to makein shaped sofa for sale.
          </p>
          {/* <Button variant="success" size="lg">
            Shop Now
          </Button> */}
        </Col>
      </Row>
    </Container>
  );
};

export default DealBanner;
